import Interceptor from "./Interceptor";

export const fetchNotifications = async (params = {}) => {
  try {
    const response = await Interceptor.get("/notifications", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const markNotificationRead = async (id) => {
  try {
    const response = await Interceptor.patch(`/notifications/${id}/read`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const markAllNotificationsRead = async () => {
  try {
    const response = await Interceptor.patch("/notifications/read-all");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteNotification = async (id) => {
  try {
    const response = await Interceptor.delete(`/notifications/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
